import { Component, OnInit, Input } from '@angular/core';
import { Icon } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-link-button',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.css']
})
export class LinkButtonComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  truncate: string;

  @Input()
  icon: Icon;

  constructor() { }

  ngOnInit() {
  }

}
